module.exports = __webpack_public_path__ + "img/嗅大了.28995ae9.gif";